'use client';
import styles from './postFilters.module.scss';
import { Button, Collapse, Spin } from 'antd';
import { __PostsFiltersPropsType } from '../posts.type';
import CategoryFiltersComp from './category/category.index';
import { CategoryFieldTypeEnum } from 'types';
import { useState } from 'react';
import PostsFilterItemComp from './filterItem/filterItem.index';

function PostFiltersComp({ filters, setFilters, filterData, onClose }: __PostsFiltersPropsType) {
    const [activeFilters, setActiveFilters] = useState(filters);

    const setFilter = () => {
        setFilters(activeFilters);
        if (onClose) onClose();
    };

    const onRemoveFilter = () => {
        setFilters({ category: filters.category, categoryFields: [] });
        setActiveFilters({ category: filters.category });
        if (onClose) onClose();
    };

    return (
        <div className={`${styles['post-filter-layout']} w-100 h-100 flex-column`}>
            {filterData ? (
                <div className="flex-column g-2 h-100">
                    <div className={`flex-1 ${styles['filter-items']}`}>
                        <CategoryFiltersComp
                            filterData={filterData}
                            filters={activeFilters}
                            setFilters={(f) => {
                                setFilters(f);
                                setActiveFilters(f);
                            }}
                        />
                        {filterData.variantFields?.map((item, index) => (
                            <Collapse
                                defaultActiveKey={
                                    item.type === CategoryFieldTypeEnum.number
                                        ? activeFilters.ranges?.map((i) => i.id).includes(item.id)
                                            ? item.id
                                            : undefined
                                        : activeFilters.categoryFields?.map((i) => i.id).includes(item.id)
                                          ? item.id
                                          : undefined
                                }
                                key={index}
                                items={[
                                    {
                                        key: item.id,
                                        label: <p className="t-400 t-p2">{item.title}</p>,
                                        children: (
                                            <PostsFilterItemComp
                                                activeFilters={activeFilters}
                                                setActiveFilters={setActiveFilters}
                                                item={item}
                                            />
                                        ),
                                    },
                                ]}
                            />
                        ))}
                    </div>
                    {filterData.variantFields?.length ? (
                        <div className="g-1 flex-pre-md-column">
                            <Button className="flex-1" onClick={setFilter}>
                                اعمال فیلتر
                            </Button>
                            <Button className="flex-1" type="primary" onClick={onRemoveFilter}>
                                حذف فیلترها
                            </Button>
                        </div>
                    ) : null}
                </div>
            ) : (
                <div className={`w-100 h-100 pv-9 center-content`}>
                    <Spin size="small" />
                </div>
            )}
        </div>
    );
}

export default PostFiltersComp;
